import axios from "axios";

import { IP_RESTRICTIONS_ENGINE_BASE_URL } from "../constants";

const show = params =>
  axios.get(`${IP_RESTRICTIONS_ENGINE_BASE_URL}/current_ip`, { params });

const currentIpApi = { show };

export default currentIpApi;
